"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const Colors_1 = require("components/styled/Colors");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const twitter = require(`../../img/social/twitter-3x.png`);
const github = require(`../../img/social/github-3x.png`);
const reddit = require(`../../img/social/reddit-3x.png`);
const keybase = require(`../../img/social/keybase-3x.png`);
const angellist = require(`../../img/social/angellist-3x.png`);
const IconsWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    justify-content: flex-end;
    margin-bottom: 48px;
  }
`;
const Circle = styled_components_1.default.div `
  background: ${Colors_1.WHITE};
  border-radius: 50%;
  height: 32px;
  opacity: 0.8;
  width: 32px;

  &:hover {
    opacity: 1;
  }
`;
const Img = styled_components_1.default.img `
  height: 32px;
`;
const IconSpacer = styled_components_1.default.div `
  width: 12px;
`;
exports.SocialIcons = () => (React.createElement(IconsWrapper, null,
    React.createElement("a", { target: "_blank", href: "https://twitter.com/stellarorg" },
        React.createElement(Circle, null,
            React.createElement(Img, { src: twitter }))),
    React.createElement(IconSpacer, null),
    React.createElement("a", { target: "_blank", href: "https://github.com/stellar" },
        React.createElement(Circle, null,
            React.createElement(Img, { src: github }))),
    React.createElement(IconSpacer, null),
    React.createElement("a", { target: "_blank", href: "https://www.reddit.com/r/Stellar/" },
        React.createElement(Circle, null,
            React.createElement(Img, { src: reddit }))),
    React.createElement(IconSpacer, null),
    React.createElement("a", { target: "_blank", href: "https://keybase.io/team/stellar.public" },
        React.createElement(Circle, null,
            React.createElement(Img, { src: keybase }))),
    React.createElement(IconSpacer, null),
    React.createElement("a", { target: "_blank", href: "https://angel.co/stellar-development-foundation/jobs" },
        React.createElement(Circle, null,
            React.createElement(Img, { src: angellist })))));



// WEBPACK FOOTER //
// ./src/components/styled/SocialIcons.tsx